<template>
    <!-- LOCATION SEARCH -->

    <Teleport to="body">
        <transition name="fade">
            <div v-show="showGeneralSearch" @click.self="closeGeneralSearch" id="locationBG"
                @keydown.esc="closeGeneralSearch"
                class="bg-gray-200/80 flex flex-col dark:bg-neutral-900/75 backdrop-blur-lg z-50 fixed top-0 left-0 h-full w-full pt-2 sm:pt-4 overflow-y-scroll md:overflow-hidden overflow-x-hidden scrollbar-hide animate-in fade-in ease-in-out duration-800 js_close_clickable">
                <div
                    class="md:hidden bg-gradient-to-b z-0 from-white dark:from-[#171717] to-transparent fixed w-full top-0 h-[20px] js_close_clickable">
                </div>
                <div class="flex mx-2 sm:mx-4 gap-2 z-[5] relative">
                    <div @click="closeGeneralSearch"
                        class="bg-white dark:bg-neutral-800 md:w-20 dark:border-neutral-700 dark:text-white h-full p-4 border border-gray-300 active:scale-75 rounded-md flex justify-center items-center animate-in zoom-in fade-in ease-in-out duration-300 js_close_clickable">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="w-6 h-6 pointer-events-none"
                            viewBox="0 0 320 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
                            <path
                                d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" />
                        </svg>
                    </div>
                    <div
                        class="bg-white w-full border border-gray-300 dark:bg-neutral-800 dark:border-neutral-700 dark:text-white md:h-[81px] rounded-md flex justify-end md:pl-6 items-center animate-in zoom-in fade-in ease-in-out duration-300 relative">
                        <input type="text" ref="search" @input="askForData" @keydown.esc="closeGeneralSearch"
                            :placeholder="$t('Search') + '...'" tabindex="0" v-model="searchName"
                            class="w-full h-full text-xl md:text-3xl text-start font-bold  border-transparent bg-transparent focus:border-transparent focus:ring-0">
                        <div v-if="searchName"
                            class="md:px-2 h-full flex items-center group cursor-pointer animate-in fade-in absolute right-14 bg-white/50 dark:bg-transparent"
                            @click="clearInput">
                            <div
                                class="p-4 flex items-center justify-center group-hover:bg-gray-200 dark:group-hover:bg-neutral-500 rounded-full transition duration-300 group-hover:scale-95 group-active:scale-75">
                                <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="currentColor"
                                    viewBox="0 0 384 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2023 Fonticons, Inc.-->
                                    <path
                                        d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
                                </svg>
                            </div>
                        </div>
                        <div class="px-2 pr-0 md:pr-4 h-full flex items-center group cursor-pointer absolute right-0"
                            @click="(e) => e.target.blur()">
                            <div
                                class="p-4 flex items-center justify-center group-hover:bg-gray-200 dark:group-hover:bg-neutral-500 rounded-full transition duration-300 group-hover:scale-95 group-active:scale-75">
                                <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="currentColor"
                                    viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2023 Fonticons, Inc.-->
                                    <path
                                        d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" />
                                </svg>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="w-full items-center px-2 md:px-4 pt-4 pb-2 flex gap-2 text-xs overflow-x-auto scrollbar-hide js_close_clickable shrink-0"
                    @click.self="closeGeneralSearch">
                    <div @click="switchType('all')" v-mouse-gradient
                        :class="[activeFilter == 'all' ? '!bg-neutral-900 dark:!bg-white !text-white dark:!text-black' : '']"
                        class="bg-white border border-gray-300 dark:bg-neutral-800 dark:border-neutral-700 px-3 py-2 rounded-full shrink-0 text-gray-700 dark:text-neutral-200 flex gap-2 items-center hover:scale-105 transition cursor-pointer">
                        <div><svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"
                                class="h-4"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
                                <path
                                    d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4 142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-64c0 35.3-28.7 64-64 64-7.1 0-13.9-1.2-20.3-3.3-5.5-1.8-11.9 1.6-11.7 7.4.3 6.9 1.3 13.8 3.2 20.7 13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1-5.8-.2-9.2 6.1-7.4 11.7 2.1 6.4 3.3 13.2 3.3 20.3z">
                                </path>
                            </svg></div>
                        <div>
                            <span class="hidden md:block">{{ $t('Search all') }}</span>
                            <span class="block md:hidden">{{ $t('All') }}</span>
                        </div>
                    </div>
                    <div @click="switchType('properties')" v-mouse-gradient
                        :class="[activeFilter == 'properties' ? '!bg-neutral-900 dark:!bg-white !text-white dark:!text-black' : '']"
                        class="bg-white border border-gray-300 dark:bg-neutral-800 dark:border-neutral-700 px-3 py-2 rounded-full shrink-0 text-indigo-400 dark:text-indigo-300 flex gap-2 items-center hover:scale-105 transition cursor-pointer">
                        <div>
                            <svg-vue icon="bed" class="h-3"></svg-vue>
                        </div>
                        <div>{{ $t('Hotels') }}</div>
                    </div>
                    <div @click="switchType('events')" v-mouse-gradient
                        :class="[activeFilter == 'events' ? '!bg-neutral-900 dark:!bg-white !text-white dark:!text-black' : '']"
                        class="bg-white border border-gray-300 dark:bg-neutral-800 dark:border-neutral-700 px-3 py-2 rounded-full shrink-0 text-red-500 dark:text-red-400 flex gap-2 items-center hover:scale-105 transition cursor-pointer">
                        <div>
                            <svg-vue icon="calendar" class="h-3"></svg-vue>
                        </div>
                        <div>{{ $t('Events') }}</div>
                    </div>
                    <div @click="switchType('locations')" v-mouse-gradient
                        :class="[activeFilter == 'locations' ? '!bg-neutral-900 dark:!bg-white !text-white dark:!text-black' : '']"
                        class="bg-white border border-gray-300 dark:bg-neutral-800 dark:border-neutral-700 px-3 py-2 rounded-full shrink-0 text-amber-500 dark:text-amber-400 flex gap-2 items-center hover:scale-105 transition cursor-pointer">
                        <div>
                            <svg-vue icon="location" class="h-3"></svg-vue>
                        </div>
                        <div>{{ $t('Places') }}</div>
                    </div>
                    <div @click="switchType('news')" v-mouse-gradient
                        :class="[activeFilter == 'news' ? '!bg-neutral-900 dark:!bg-white !text-white dark:!text-black' : '']"
                        class="bg-white border border-gray-300 dark:bg-neutral-800 dark:border-neutral-700 px-3 py-2 rounded-full shrink-0 text-gray-500 dark:text-neutral-400 flex gap-2 items-center hover:scale-105 transition cursor-pointer">
                        <div>
                            <svg-vue icon="news" class="h-3"></svg-vue>
                        </div>
                        <div>{{ $t('News') }}</div>
                    </div>
                    <button type='button' @click="switchToCalendar" v-mouse-gradient
                        class="hidden md:flex ml-auto bg-white border border-gray-300 dark:bg-neutral-800 dark:border-neutral-700 px-3 py-2 rounded-full shrink-0 text-gray-500 dark:text-neutral-400 flex gap-2 items-center hover:scale-105 transition cursor-pointer">
                        <div>
                            <svg-vue icon="search-solid" class="h-3"></svg-vue>
                        </div>
                        <div>{{ $t('Search on date') }}</div>
                    </button>
                </div>
                <div
                    class="md:hidden bg-gradient-to-t z-0 from-white dark:from-[#171717] to-transparent fixed w-full bottom-0 h-[50px] js_close_clickable">
                </div>
                <div v-show="loading" @click.self="closeGeneralSearch"
                    class="duration-500 ease-in-out js_close_clickable dark:text-white shrink-0">
                    <h2 class="font-bold text-xl sm:text-3xl mb-4 mt-2 px-4 js_close_clickable dark:text-white w-fit">
                        {{ $t('Searching') }}...</h2>
                    <div
                        class="flex gap-4 max-w-full snap-x scroll-pl-8 snap-proximity overflow-x-scroll scrollbar-hide animate-in fade-in animate-out slide-out-from-left ease-out duration-800 fade-in px-4">
                        <div v-for="n in 10"
                            class="flex flex-col gap-4 animate-in fade-in animate-out slide-out-from-left fade-out snap-start transition cursor-pointer group">
                            <div
                                class="flex items-center justify-center h-[130px] w-[130px] sm:h-[200px] sm:w-[200px] bg-white dark:bg-neutral-800 animate-pulse rounded-lg">
                                <svg class="w-10 h-10 text-gray-200 dark:text-neutral-500 " aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 18">
                                    <path
                                        d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <h2
                        class="font-bold text-3xl mt-8 mb-4 h-[30px] py-3 w-[100px] bg-gray-400 dark:bg-neutral-500 animate-pulse rounded-full mx-4 js_close_clickable">
                    </h2>
                    <div class="flex flex-col md:flex-row gap-4 mb-8 px-4">
                        <div v-for="n in 10" class="flex flex-col gap-4 flex-wrap ">
                            <div
                                class="flex items-center justify-start h-[100px] w-[400px] bg-white dark:bg-neutral-800 animate-pulse rounded-lg px-4">
                                <svg class="w-10 h-10 text-gray-200 dark:text-neutral-500" aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 18">
                                    <path
                                        d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-show="!loading" @click.self="closeGeneralSearch"
                    class="animate-in fade-in duration-500 ease-in-out js_close_clickable dark:text-white h-full grow-0 overflow-x-auto scrollbar-hide pb-22 top_gradient_mask">
                    <div v-for="category in orderedCategories" :key="category.key"
                        v-if="result[category.key] && result[category.key].length" class="mt-4 mb-8">
                        <h4
                            class="text-base sm:text-md text-gray-600 dark:text-neutral-300 js_close_clickable px-2 md:px-4">
                            {{ $t(category.label) }}
                        </h4>

                        <div v-if="category.key != 'categories'"
                            class="flex gap-4 max-w-full px-2 md:px-4 snap-x scroll-pl-2 md:scroll-pl-4 snap-proximity pt-2 animate-in ease-out duration-500 fade-in js_close_clickable"
                            :class="{ 'overflow-x-scroll scrollbar-hide': result[category.key].length > 1 }"
                            @click.self="closeGeneralSearch">
                            <div v-for="(item, _) in result[category.key]" :key="item.id"
                                @click="handleItemClick($event, item, category.key)"
                                class="flex flex-col animate-in fade-in snap-start transition cursor-pointer group select-none">
                                <div v-mouse-gradient
                                    class="bg-white dark:bg-neutral-800 overflow-hidden rounded-lg h-[130px] w-[130px] sm:h-[150px] sm:w-[150px] lg:h-[170px] lg:w-[170px] flex justify-center items-center shadow-lg group-hover:shadow-none group-hover:scale-95 group-active:scale-80 transition relative select-none">
                                    <div v-if="item.sponsored && item.sponsored == true" @click.stop
                                        :href="$baseUrl + '/termsandconditions#sponsored'" target="blank"
                                        class="bg-black/50 backdrop-blur-sm p-2 rounded-full absolute left-2 top-2 text-gray-200 hover:text-yellow-400 z-5 transition-all duration-500 flex items-center justify-start group/promotion max-w-[32px] hover:max-w-full overflow-hidden">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 576 512"
                                            class="w-4 h-4 shrink-0">
                                            <path
                                                d="M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0L86.4 427.4c5.5 30.4 32 52.6 63 52.6H426.6c30.9 0 57.4-22.1 63-52.6L535.3 176c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106z">
                                            </path>
                                        </svg>
                                        <span
                                            class="text-xs ml-1 opacity-0 transition group-hover/promotion:opacity-100 text-white">
                                            {{ $t('sponsored') }}
                                        </span>
                                    </div>
                                    <likebutton v-if="item.id" :id="item.id"
                                        background="absolute top-2 right-2 bg-black/50 backdrop-blur-sm"
                                        color="text-gray-100" />
                                    <template v-if="item['logo_link']">
                                        <img class="w-full h-full pointer-events-none bg-gray-300 object-cover select-none"
                                            :src="item['logo_link']" :title="item.name" loading="lazy" />
                                    </template>
                                    <template v-else-if="item[category.imageField]">
                                        <img class="w-full h-full pointer-events-none bg-gray-300 object-cover select-none"
                                            :src="item[category.imageField]" :title="item.name" loading="lazy" />
                                    </template>
                                    <template v-else>
                                        <div class="w-full h-full bg-primary flex justify-center items-center select-none">
                                            <span class="text-xs text-white/50">{{ $t('no image') }}</span>
                                        </div>
                                    </template>
                                </div>
                                <div class="max-w-[130px] sm:max-w-[200px] overflow-hidden relative h-6 mt-2">
                                    <span class="scroll_long_text text-sm sm:text-base">
                                        {{ item.name ? getTranslated(item.name) : getTranslated(item.title) }}
                                    </span>
                                </div>
                                <template v-if="category.key == 'properties'">
                                    <span class="text-xs text-gray-500 dark:text-neutral-400">{{ item.address }}</span>
                                </template>
                                <template v-else-if="category.key == 'events'">
                                    <span class="text-xs text-gray-500 dark:text-neutral-400">{{ item.locations[0] ?
                                        getTranslated(item.locations[0].name) : null }}</span>
                                    <div class="w-full overflow-hidden relative h-4">
                                        <span
                                            class="scroll_long_text text-xs text-primary-darkish dark:text-primary capitalize">
                                            <template v-if="item.event_repeats && item.event_repeats.length > 0">
                                                {{ formatRepeats(item) }}
                                            </template>
                                            <template v-else-if="item.event_items && item.event_items.length > 0">
                                                {{ formatEventItems(item) }}
                                            </template>
                                            <template v-else>
                                                {{ formatDate(item.start, item.end) }}
                                            </template>
                                        </span>
                                    </div>
                                </template>
                                <template v-else-if="category.key == 'locations'">
                                    <category_type :type="item.type" variant="inline" class="mt-1"></category_type>
                                </template>
                            </div>
                            <div
                                class="flex flex-col animate-in fade-in snap-start transition cursor-pointer group select-none">
                                <div @click="openOverviewPage(category.key)" v-mouse-gradient :href="$baseUrl + '/'"
                                    class="flex flex-col overflow-hidden rounded-lg h-[130px] w-[130px] sm:h-[150px] sm:w-[150px] lg:h-[170px] lg:w-[170px] flex justify-center items-center group-hover:scale-95 group-active:scale-80 transition relative select-none">
                                    <div
                                        class="w-14 h-14 mb-4 bg-primary text-white dark:text-neutral-900 rounded-full flex justify-center items-center select-none">
                                        <svg-vue icon="chevron-down" class="w-5 h-5 -rotate-90"></svg-vue>
                                    </div>
                                    <span class="text-xs text-gray-500 dark:text-neutral-400 text-center">{{ $t('All') }} {{ category.label }}</span>
                                </div>
                            </div>
                        </div>
                        <div v-else class="flex flex-wrap gap-2 px-2 md:px-4 pt-2" @click.self="closeGeneralSearch">
                            <div v-for="(item, _) in result[category.key]"
                                @click="handleItemClick($event, item, category.key)" v-mouse-gradient
                                class="bg-white border border-gray-300 dark:bg-neutral-800 dark:border-neutral-700 px-3 py-2 rounded-full shrink-0 flex gap-2 items-center hover:scale-105 transition cursor-pointer active:scale-80">
                                <div class="text-xs capitalize">
                                    {{ getTranslated(item.name) }}
                                </div>
                            </div>
                            <a :href="$baseUrl + '/categories'" v-mouse-gradient
                                class="bg-white border border-primary dark:bg-neutral-800 text-primary pl-3 pr-2 py-2 rounded-full shrink-0 flex gap-2 items-center hover:scale-105 transition cursor-pointer active:scale-80">
                                <div class="text-xs">
                                    {{ $t('All') }} {{ $t('Categories') }}
                                </div>
                                <div
                                    class="w-4 h-4 bg-primary text-white dark:text-neutral-900 rounded-full flex justify-center items-center select-none">
                                    <svg-vue icon="chevron-down" class="w-3 h-3 -rotate-90"></svg-vue>
                                </div>
                            </a>
                        </div>
                    </div>

                    <!-- Fallback message -->
                    <div v-if="!categories.some(cat => result[cat.key] && result[cat.key].length)"
                        @click="closeGeneralSearch"
                        class="flex flex-col justify-center items-center p-4 text-center text-gray-500 dark:text-neutral-400">
                        <span class="text-5xl md:text-7xl mb-2">😅</span>
                        <span>{{ $t('No results found') }}</span>
                    </div>
                </div>
            </div>
        </transition>
    </Teleport>
</template>
  
<script>
const { debounce } = require("lodash");
import VueCookies from 'vue-cookies'
import eventHelpers from '../../../eventHelpers'

export default {
    data() {
        return {
            showGeneralSearch: false,
            search: null,
            searchName: "",
            activeFilter: 'all',
            result: [],
            loading: true,
            categories: [
                { key: 'properties', label: this.$t('Accommodations'), imageField: 'spotlightimage' },
                { key: 'events', label: this.$t('Events'), imageField: 'image_link' },
                { key: 'locations', label: this.$t('Places'), imageField: 'image_link' },
                { key: 'news', label: this.$t('News'), imageField: 'image_link' },
                { key: 'categories', label: this.$t('Categories'), imageField: 'image_link' },
            ],
            search: new URLSearchParams(window.location.search),
        };
    },
    mounted() {
        this.$root.$on("showGeneralSearch", (msg) => {
            $("body").addClass("scroll_lock");
            this.askForData();
            this.showGeneralSearch = msg;
            this.$refs.search.focus();
        });
    },
    computed: {
        orderedCategories() {
            if (!this.activeFilter || this.activeFilter === 'all') {
                return this.categories;
            }

            // find the active category and move it to the front
            const active = this.categories.find(c => c.key === this.activeFilter);
            const rest = this.categories.filter(c => c.key !== this.activeFilter);

            return active ? [active, ...rest] : this.categories;
        }
    },
    methods: {
        ...eventHelpers,
        switchType(type) {
            this.activeFilter = type;
            this.askForData();
        },
        closeGeneralSearch() {
            $("body").removeClass("scroll_lock")
            this.showGeneralSearch = false;
        },
        openOverviewPage(key) {
            const routes = {
                properties: '/acco/',
                events: '/events/',
                locations: '/locations/',
                news: '/news/',
                categories: '/categories/'
            }

            if (routes[key]) {
                window.location.href = this.$baseUrl + routes[key];
            }
        },
        handleItemClick(event, item, key) {
            if (event.target.closest('likebutton')) return;

            const routes = {
                properties: '/acco/',
                events: '/events/',
                locations: '/locations/',
                news: '/news/',
                categories: '/categories/'
            }

            if (routes[key]) {
                window.location.href = this.$baseUrl + routes[key] + item.slug
            }
        },
        async handleLocationInput() {
            if (this.$refs.search && this.$refs.search.value == "") {
                this.search = '';
                VueCookies.set('search', '')
            }

            this.loading = true;
            this.result = [];
            try {
                let response = await fetch(
                    "/resources/search?search=" + this.$refs.search.value + "&type=" + this.activeFilter,
                    {
                        credentials: 'same-origin',
                        headers: {
                            "Content-Type": "text/plain",
                        },
                    }
                );
                this.result = await response.json();
                this.loading = false;
            } catch (error) {
                this.loading = false;
            }
        },
        fetch: _.debounce(function () {
            this.handleLocationInput()
        }, 1000),
        askForData: function () {
            this.loading = true;
            this.result = [];
            this.fetch();
        },
        switchToCalendar(e) {
            VueCookies.set('searchlocation', null)
            this.searchlocation = null;
            this.showLocationSearch = false
            this.$root.$emit("locationChange", null);
            this.$root.$emit("showCalendarSearch", true);
        },
        clearInput() {
            this.search = null;
            this.searchName = null;
            VueCookies.set('search', null);
            this.askForData();
        },
        getTranslated(item, lang = 'en') {
            if (!item) return '';

            // if item is already a string, just return it
            if (typeof item === 'string') {
                return item;
            }

            // otherwise, assume it's an object with translations
            return item[lang] || item['en'] || '';
        }
    },

    watch: {
    },

    created() {
    },
};
</script>
  